module.exports = __webpack_public_path__ + "static/media/tetra_logo.67309569.png";